export default {
  productsection: 'Product section',
  productsections: 'Product sections',
  verbose_productsection: 'a product section',
};
